/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  user: {},
  error: null,
};

const getters = {
  user: state => state.user,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/users/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveUser({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.selectedUser.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/users/${payload.selectedUser.id}`, payload.selectedUser);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/users`, payload.selectedUser);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/users/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  deleteBulk({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/users/bulk`, { params: { ids: payload.ids, _method: 'DELETE' } })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  fetchReport({ commit }, payload) {
    return Vue.http.get(`${getApiPath(payload.user)}/users/report`, { data: payload.data });
  },
  setPassword({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/users/${payload.userId}/password`, payload.data)
      .then(() => {
        commit(mTypes.DATA_ERROR, null);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, user) {
    state.user = user.data;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.user = {};
  },
  [mTypes.DATA_STORED](state, user) {
    state.user = user.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  vehicle_attached_to_permit(state, vehiclePermitRealation) {
    const vehicleIndex = state.user.vehicles.findIndex(obj =>
      obj.permitId.findIndex(o => o === vehiclePermitRealation.permitId) !== -1,
    );
    if (vehicleIndex !== -1) {
      state.user.vehicles[vehicleIndex].permitId = state.user.vehicles[vehicleIndex]
        .permitId.filter(e => e !== vehiclePermitRealation.permitId);
    }
    if (vehiclePermitRealation.vehicleId !== '') {
      const index = state.user.vehicles.findIndex(obj =>
        obj.id === vehiclePermitRealation.vehicleId,
      );
      if (index !== -1) {
        state.user.vehicles[index].permitId.push(vehiclePermitRealation.permitId);
      }
    }
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/user.js